export default "__VITE_ASSET__BRFv1o0S__"